<p-toast class="custom-toast" />
<p-drawer
  [visible]="visible()"
  (onHide)="onDrawerHide()"
  position="right"
  [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
  styleClass="layout-config-sidebar w-80"
  header="Configurações"
>
  <div class="flex flex-col gap-6">
    <div>
      <div class="flex flex-col gap-2">
        <span class="text-lg text-muted-color font-semibold">Idiomas</span>
        <p-selectbutton
          [options]="languages"
          [(ngModel)]="currentLanguage"
          (onChange)="updateLanguage()"
          [allowEmpty]="false"
          optionLabel="name"
          optionValue="value"
        ></p-selectbutton>
      </div>
    </div>

    @if (
      canSeeCameraGroupTab() ||
      canSeeUserTab() ||
      canSeePermissionLevelTab() ||
      canSeeFaceLowQuality() ||
      canSeeCaptureDashboard() ||
      canSeeWhatsappIntegrationTab() ||
      canSeeUsageMetricsItem()
    ) {
      <div>
        <div class="flex flex-col gap-2">
          <span class="text-lg text-muted-color font-semibold">{{
            'configurator.management' | translate
          }}</span>
          @if (canSeeCameraGroupTab()) {
            <a
              [routerLink]="['/group-cameras']"
              (click)="onDrawerHide()"
              class="flex items-center gap-2 text-sm text-color hover:text-primary cursor-pointer py-1"
            >
              <i class="pi pi-objects-column"></i>
              {{ 'configurator.camera_groups' | translate }}
            </a>
          }
          @if (canSeeUserTab()) {
            <a
              [routerLink]="['/users']"
              (click)="onDrawerHide()"
              class="flex items-center gap-2 text-sm text-color hover:text-primary cursor-pointer py-1"
            >
              <i class="pi pi-users"></i>
              {{ 'configurator.users' | translate }}
            </a>
          }
          @if (canSeePermissionLevelTab()) {
            <a
              [routerLink]="['/permission-levels']"
              (click)="onDrawerHide()"
              class="flex items-center gap-2 text-sm text-color hover:text-primary cursor-pointer py-1"
            >
              <i class="pi pi-shield"></i>
              {{ 'configurator.permission_levels' | translate }}
            </a>
          }
          @if (canSeeFaceLowQuality()) {
            <a
              [routerLink]="['/face-low-quality']"
              (click)="onDrawerHide()"
              class="flex items-center gap-2 text-sm text-color hover:text-primary cursor-pointer py-1"
            >
              <i class="pi pi-image"></i>
              Faces Desqualificadas
            </a>
          }
          @if (canSeeCaptureDashboard()) {
            <a
              [routerLink]="['/configuracoes/dashboard-capturas']"
              (click)="onDrawerHide()"
              class="flex items-center gap-2 text-sm text-color hover:text-primary cursor-pointer py-1"
            >
              <i class="pi pi-chart-bar"></i>
              Dashboard de Capturas LPR e Facial
            </a>
          }
          @if (canSeeWhatsappIntegrationTab()) {
            <a
              [routerLink]="whatsappIntegrationRoute()"
              [queryParams]="whatsappIntegrationQueryParams()"
              (click)="onDrawerHide()"
              class="flex items-center gap-2 text-sm text-color hover:text-primary cursor-pointer py-1"
            >
              <i class="pi pi-whatsapp"></i>
              {{ 'configurator.whatsapp_integration' | translate }}
            </a>
          }
          @if (canSeeUsageMetricsItem()) {
            @if (canSeeUsageMetrics()) {
              <a
                [routerLink]="[usageMetricsRoute]"
                (click)="onDrawerHide()"
                class="flex items-center gap-2 text-sm text-color hover:text-primary cursor-pointer py-1"
              >
                <i class="pi pi-chart-bar"></i>
                {{ 'configurator.usage_metrics' | translate }}
              </a>
            } @else {
              <button
                type="button"
                aria-disabled="true"
                data-testid="usage-metrics-locked"
                [attr.aria-label]="
                  'configurator.usage_metrics_locked' | translate
                "
                (click)="showUsageMetricsAccessDenied()"
                class="flex items-center gap-2 text-sm text-muted-color cursor-not-allowed py-1 text-left"
              >
                <i class="pi pi-chart-bar"></i>
                {{ 'configurator.usage_metrics' | translate }}
                <i class="pi pi-lock text-xs" aria-hidden="true"></i>
              </button>
            }
          }
        </div>
      </div>
    }

    @if (canSeeServicePackagesTab()) {
      <div>
        <div class="flex flex-col gap-2">
          <span class="text-lg text-muted-color font-semibold">{{
            'configurator.financial' | translate
          }}</span>
          <a
            [routerLink]="['/configuracoes/gerenciamento/pacotes-servico']"
            (click)="onDrawerHide()"
            class="flex items-center gap-2 text-sm text-color hover:text-primary cursor-pointer py-1"
          >
            <i class="pi pi-box"></i>
            {{ 'configurator.service_packages' | translate }}
          </a>
        </div>
      </div>
    }

    <div>
      <div class="flex flex-col gap-3">
        <span class="text-lg text-muted-color font-semibold">Notificações</span>

        <div class="flex flex-col gap-2">
          @if (isNotificationBlocked()) {
            <div
              style="
                background: #fff3cd;
                border: 1px solid #ffc107;
                padding: 12px;
                border-radius: 4px;
                margin-bottom: 12px;
              "
            >
              <p style="margin: 0; color: #856404">
                <strong>Notificações bloqueadas.</strong>
                Clique no icone ao lado esquerdo da URL do navegador e altere
                para "Permitir".
              </p>
            </div>
          }
          @for (notification of notificationMap; track notification) {
            <div class="flex align-items-center gap-2">
              @if (notification.visible) {
                <p-toggleSwitch
                  [id]="notification.key"
                  [ngModel]="getNotificationValue(notification.key)"
                  (ngModelChange)="
                    updateNotificationPreference(notification.key, $event)
                  "
                  [disabled]="
                    isNotificationBlocked() ||
                    (notification.key !== 'pushAll' &&
                      !notificationPreference().pushAll)
                  "
                ></p-toggleSwitch>
              }
              @if (notification.visible) {
                <label [for]="notification.key" class="cursor-pointer">
                  {{ notification.label }}
                </label>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="text-xs text-muted-color opacity-50 text-center select-none">
      v{{ appVersion }} &nbsp;&bull;&nbsp; App {{ angularVersion }}
    </div>
  </ng-template>
</p-drawer>
